import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { useBoolean } from 'usehooks-ts';

import AppMeta from 'components/App/Meta';
import AppBreadcrumb from 'components/App/Breadcrumb';
import RoomCard from 'components/DashboardPage/Location/RoomCard';
import ModalRequestAction from 'components/Modals/ModalRequestAction';
import ModalSuccess from 'components/Modals/ModalSuccess';
import Loading from 'components/App/Loading';

import images from 'assets/images';
import { ReactComponent as AddRoomButtonSVG } from 'assets/images/queue.svg';
import { LOCATIONS } from 'constants/index';
import INITIAL_VALUE from 'constants/initialValue';
import MODAL_TYPE from 'constants/modalType';

import styles from './RoomsOfPlace.module.scss';

function RoomsOfPlace(props) {
  const {
    isLoadingGetRoomsOfPlace,
    isLoadingDeleteRoomOfPlace,

    modalType,

    location,
    roomsOfPlace,

    actionDeleteRoomOfPlace,
    actionGetRoomsOfPlace,
    actionCloseModalCreateRoomSuccess,
  } = props;

  const [roomId, setRoomId] = React.useState('');

  const placeId = React.useMemo(() => new URLSearchParams(location.search).get('place') || '', [location]);

  const breadcrumbList = [
    {
      name: 'Chỗ nghỉ',
      isActive: false,
      link: `${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${placeId}`,
    },

    {
      name: 'Loại phòng',
      isActive: true,
    },
  ];

  const {
    value: isOpenModalDeleteRoom,
    setFalse: onCloseModalDeleteRoom,
    setTrue: onOpenModalDeleteRoom,
    toggle: onToggleModalDeleteRoom,
  } = useBoolean(false);

  const onConfirmDeleteRoom = React.useCallback(() => {
    actionDeleteRoomOfPlace({ placeId, roomId, callback: onCloseModalDeleteRoom });
  }, [placeId, roomId]);

  React.useEffect(() => {
    actionGetRoomsOfPlace({ placeId });
  }, [placeId]);

  return (
    <div className="page-content">
      <Loading
        loaderOnPage
        loading={isLoadingGetRoomsOfPlace || isLoadingDeleteRoomOfPlace}
      />

      <div className={styles.Page}>
        <AppMeta name="Loại phòng" />

        <Container fluid>
          <div className="Breadcrumb">
            <AppBreadcrumb
              pageTitle="Loại phòng"
              breadcrumbList={breadcrumbList}
            />
          </div>

          <Row className="CardContainer">
            {roomsOfPlace.map((room) => (
              <Col xs="12" md="6" lg="3" key={room._id}>
                <RoomCard
                  placeId={placeId}
                  roomData={room}
                  onOpenModalDeleteRoom={onOpenModalDeleteRoom}
                  setRoomId={setRoomId}
                />
              </Col>
            ))}

            <Col xs="12" md="6" lg="3" title="Tạo phòng mới">
              <Link
                to={{
                  pathname: LOCATIONS.LOCATION_DETAIL.CREATE_ROOM,
                  search: `?place=${placeId}`,
                }}
                className="Card__AddRoom"
              >
                <AddRoomButtonSVG />

                <span>TẠO PHÒNG MỚI</span>
              </Link>
            </Col>
          </Row>

        </Container>

        <ModalSuccess
          isOpen={modalType === MODAL_TYPE.CREATE_ROOM_SUCCESS}
          onCloseModal={actionCloseModalCreateRoomSuccess}
          message="Bạn đã tạo phòng thành công"
        />

        <ModalRequestAction
          isOpen={isOpenModalDeleteRoom}
          icon={images.modalGarbageCan.default}
          textRequest="Bạn có chắc muốn xóa phòng này không?"
          onToggle={onToggleModalDeleteRoom}
          onCloseModal={onCloseModalDeleteRoom}
          onConfirm={onConfirmDeleteRoom}
        />
      </div>
    </div>
  );
}

RoomsOfPlace.propTypes = {
  isLoadingGetRoomsOfPlace: PropTypes.bool,
  isLoadingDeleteRoomOfPlace: PropTypes.bool,

  modalType: PropTypes.string,

  location: PropTypes.instanceOf(Object).isRequired,
  roomsOfPlace: PropTypes.instanceOf(Array),

  actionDeleteRoomOfPlace: PropTypes.func,
  actionGetRoomsOfPlace: PropTypes.func,
  actionCloseModalCreateRoomSuccess: PropTypes.func.isRequired,
};

RoomsOfPlace.defaultProps = {
  isLoadingGetRoomsOfPlace: false,
  isLoadingDeleteRoomOfPlace: false,

  modalType: '',

  roomsOfPlace: [],

  actionDeleteRoomOfPlace: INITIAL_VALUE.FUNCTION,
  actionGetRoomsOfPlace: INITIAL_VALUE.FUNCTION,
};

export default RoomsOfPlace;
